<template>
  <div>
    <fixed-header id="sticky-header">
      <div class="row form-header">
        <div class="col-sm-4 col-xl-4 m-auto">
          <router-link 
            class="h6"
            tag="a"
            to="/candidate"
          >
            <i class="uil-arrow-left"></i> {{$t('candidate.plural').toUpperCase()}}
          </router-link>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="mt-4 mt-md-0">
            <!-- <a href="javascript:void(0)"
              @click="addAttachment" class="btn btn-sm mx-1"><feather type="file-plus" class="icon-md"></feather></a> -->

            <input 
              type='file' 
              id="attachmentUpload" 
              hidden=true
              @change="addAttachment" />
            <label for="attachmentUpload" class="btn btn-sm m-0 mx-1 text-muted"><feather type="file-plus" class="icon-md"></feather></label>

           <!--  <a href="javascript:void(0)"
              onclick="alert('Pending')" class="btn btn-sm mx-1"><feather type="mail" class="icon-md"></feather></a>
            
            <a href="javascript:void(0)"
              onclick="alert('Pending')" class="btn btn-sm mx-1"><feather type="calendar" class="icon-md"></feather></a> -->

            <router-link
              tag="button"
              :to="'edit?id=' + $route.query.id"
              class="btn btn-info btn-sm"
            >
              <i class="uil uil-edit mr-1"></i>{{$t('common.edit')}}
            </router-link>

          </div>
        </div>
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body pb-0">
            <div class="media">
              <img
                ref="imageAvatar"
                src="@assets/images/users/avatar-7.jpg"
                class="mr-3 avatar-xxl rounded-circle"
                alt="avatar"
              />
              <div class="row media-body">
                <div class="col-lg-6 mt-2 pt-3 border-top text-left">
                  <h5 class="mt-3 mb-0">{{ model.full_name }}</h5>
                  <h6 class="my-2" v-if="model.jp_first_name">{{ model.jp_full_name }}</h6>
                  <h6 class="font-weight-normal mt-1 mb-4 text-muted">
                    {{ model.present_work }}
                  </h6>
                </div>
                <div class="col-lg-6">
                  <div class="mt-2 pt-3 border-top text-left">
                    <ul class="list-unstyled events mb-0 font-1 text-muted">
                      <li class="my-2" v-if="model.gender"><i class="mr-2 uil-user"></i> {{model.gender | capitalize}}</li>
                      <li class="my-2" v-if="model.date_of_birth"><i class="mr-2 uil-gift"></i> {{ model.date_of_birth | date}}</li>
                      <li class="my-2" v-if="model.country"><i class="mr-2 uil-location-point"></i> {{model.city}} {{model.country}}</li>
                      <li class="my-2" v-if="model.contact_no"><i class="mr-2 uil-phone"></i> {{ model.contact_no }}</li>
                      <li class="my-2" v-if="model.email"><i class="mr-2 uil-envelope"></i> {{model.email}}</li>
                      <li class="my-2" v-if="model.skype"><i class="mr-2 uil-skype"></i> king_munoz_12</li>
                      <li class="my-2" v-if="model.website"><i class="mr-2 uil-globe"></i> wwww.rickyignacio.com</li>
                    </ul>

                    <div class="social-feeds">
                      <a href="" v-if="model.facebook"><i class="uil-facebook"></i></a>
                      <a href="" v-if="model.twitter"><i class="uil-twitter text-info"></i></a>
                      <a href="" v-if="model.dribble"><i class="uil-dribbble text-danger"></i></a>
                      <a href="" v-if="model.behance"><i class="uil-behance"></i></a>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
            <b-tabs>
              <b-tab title="Documents" active>
                <div class="row">
                  <div class="text-left col-lg-8">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title pb-2 border-bottom">Resume</h5>
                          <VuePerfectScrollbar style="max-height: 800px">
                            <div>
                              <pdf
                                v-for="i in numPages"
                                :key="i"
                                :src="src"
                                :page="i"
                                style="display: inline-block; width: 100%"
                              ></pdf>
                            </div>
                          </VuePerfectScrollbar>
                      </div>
                    </div>  
                  </div>
                  <div class="text-left col-lg-4">
                    <h4 class="mb-3 font-size-15">{{$t('candidate.form.attachments')}}</h4>
                    <div class="text-center my-4"
                        v-if="!model.attachments.length"
                      >{{$t('candidate.form.empty_attachments')}}.</div>

                    <VuePerfectScrollbar style="max-height: 300px">
  
                      <div class="card mb-2 shadow-none border"
                        v-for="(item, idx) in model.attachments"
                        :key="`item-${item._id}`"
                      >
                        <div class="p-1 px-2">
                          <div class="row align-items-center">
                              <div class="col-auto">
                                  <img src="@assets/images/projects/project-1.jpg" class="avatar-sm rounded" alt="file-image">
                              </div>
                              <div class="col pl-0" style="white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;">
                                  <a href="javascript:void(0);" class="text-muted font-weight-bold">{{ item.originalname }}</a>
                                  <p class="mb-0">{{ item.size.$numberDecimal | bytes}}</p>
                              </div>
                              <div class="col-auto">
                                  <a
                                    @click="onDownloadAttachment(item._id, idx)"
                                    data-toggle="tooltip" 
                                    data-placement="bottom" title="Download Attachment" class="btn btn-link text-muted btn-lg p-0" 
                                    data-original-title="Download">
                                      <i class="uil uil-cloud-download font-size-14"></i>
                                  </a>
                                  <a
                                    @click="onDeleteAttachment(item._id, idx)"
                                    data-toggle="tooltip" data-placement="bottom" title="Delete Attachment" class="btn btn-link text-danger btn-lg p-0" data-original-title="Delete">
                                      <i class="uil uil-multiply font-size-14"></i>
                                  </a>
                              </div>
                          </div>
                        </div>
                      </div>
                    </VuePerfectScrollbar>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Activities & Applied Position">
                <div class="row col-lg-12">
                  <div class="card col-lg-6">
                    <div class="card-title p-2 m-0 border-bottom header-title">{{$t('candidate.form.applied_position')}}</div>
                    <div class="card-body bg-light">

                      <div class="text-center"
                          v-if="!model.applications.length"
                        >No application/s found.</div>

                      <VuePerfectScrollbar style="max-height: 500px">
                        <div
                          class="card mb-2"
                          v-for="item in model.applications"
                          :key="item._id">
                            <div class="p-2">
                              <applicantProgress 
                                :status="item.status"
                                :applicant="item"
                                employment
                              />
                            </div>
                        </div>
                      </VuePerfectScrollbar>

                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="card">
                      <div class="card-body">

                        <h5 class="card-title pb-2 border-bottom">{{$t('candidate.form.activities')}}</h5>
                        
                        <VuePerfectScrollbar style="max-height: 500px">
                          <div 
                            class="text-center"
                            v-if="!model.activities.length"
                            >{{$t('candidate.form.empty_activities')}}.</div>

                            <div class="custom-timeline pl-4" 
                              v-for="item in model.activities"
                              :key="item._id"
                            >
                              <ul class="list-unstyled events">
                                <li class="event-list" >
                                  <div v-if="item.type == 'application'">
                                    <div class="event-date text-muted pt-2">
                                      <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}} | {{ item.recruiter_id ? item.recruiter_id.full_name : '' }} </span>
                                    </div>
                                    <div class="media">
                                      <div class="media-body">
                                        
                                        <div class="card">
                                          <div class="card-body mt-3">
                                            <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                            <p class="text-muted">
                                              {{ item.description }}
                                            </p>
                                            <div v-if="item.job_id">Position: {{ item.job_id.title }}</div>
                                            <div v-if="item.job_id">Company: {{ item.job_id.company_id.name }}</div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                  <div v-else-if="item.type == 'schedule' || item.type == 'reschedule'">
                                    <div class="event-date text-muted pt-2">
                                      <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}}</span>
                                    </div>
                                    <div class="media">
                                      <div class="media-body">
                                        
                                        <div class="card">
                                          <div class="card-body mt-3">
                                            <h5 class="mt-0"><i class="uil uil-calendar-alt"></i> {{ item.title }}</h5>
                                            <p class="text-muted">
                                              {{ item.description }}
                                            </p>
                                            <div v-if="item.job_id">Position: {{ item.job_id.title }}</div>
                                            <div v-if="item.job_id">Company: {{ item.job_id.company_id.name }}</div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div class="event-date text-muted pt-2">
                                      <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}}</span>
                                    </div>
                                    <div class="media">
                                      <div class="media-body">
                                        
                                        <div class="card">
                                          <div class="card-body mt-3">
                                            <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                            <p class="text-muted">
                                              {{ item.description }}
                                            </p>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>

                        </VuePerfectScrollbar>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import FixedHeader from 'vue-fixed-header'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment/moment'
import applicantProgress from '@components/applicantProgress'
import pdf from 'vue-pdf'

var loadingTask = pdf.createLoadingTask('http://localhost:12345/uploads/candidate/1625454058Rommel-Ignacio-Resume-1%20(2).pdf');

export default {
  mixins: [FormMixin],
  components:{FixedHeader, VuePerfectScrollbar, applicantProgress, pdf},
  data(){
    return {
      model:{
        full_name: '',
        jp_full_name: '',
        email: '',
        contact_no: '',
        work_experiences:[],
        education_background:[],
        skills:[],
        tags:[],
        attachments:[],
        activities:[],
        applications:[],
        job_id:{
          title:'',
          company_id:{
            name:''
          }
        }
      },
      application:{},
      tag:{},
      showTag:false,
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      src: loadingTask,
			numPages: undefined
    }
  },
  /* computed: {
    present_work: function() {
      let position
      for(var key in this.model.work_experiences){
        var work = this.model.work_experiences[key]
        if(work.present == true){
          position = work.position
        }
      }
      return position
    },
  }, */
  beforeMount(){
    window.addEventListener('resize', this.handleResize)
    this.fetchData()
  },
  mounted() {
		this.src.promise.then(pdf => {
      this.numPages = pdf.numPages;
		});
	},
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('candidate', ['findCandidate', 'uploadAttachment', 'downloadAttachment', 'deleteAttachment', 'createTag', 'removeTag']),
    toggleViewer(){
      this.$refs.html2Pdf.generateReport(this.model._id, 'candidate')
    },
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}

      this.create(this.model)
      .then(()=> {
        this.toggleLoading()
         this.$router.push('/administration/user')
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    onAddTag(){
      
      if(this.tag.name){
        delete this.tag._idx

        this.tag.candidate_id = this.$route.query.id
        this.createTag(this.tag).then(res => {
          this.model.tags.push(res.data)
        })

        this.tag = {}
        this.showTag = false
      }else{
        this.showTag = true
      }

    },
    onDeleteTag(idx, item){

      this.removeTag(item).then(res => {
        if(res.data.ok == 1){
          this.model.tags.splice(idx, 1)
          this.tag = {}
        }else{
          alert('Please try again')
        }
      })
    },
    async fetchData(){

      await this.findCandidate({
        id:this.$route.query.id
      }).then(res => {
        this.model = res.data

        if(this.model.avatar_path){
          this.$refs['imageAvatar'].src = this.model.avatar_path
        }
      })
    },
    addAttachment(e) {
      let input = e.target

      if (input.files && input.files[0]) {
        this.toggleLoading()
        
        var formData = new FormData();

        formData.append("file", input.files[0]);
        formData.append("id", this.$route.query.id);

        this.uploadAttachment(formData).then(res => {
          if(res.data.success == true){
            this.model.attachments.push(res.data.attachment)
            /* var reader = new FileReader();

            reader.onload = (a) => {
              this.$refs['imagePreview'].src = a.target.result
              NProgress.done()
            }

            reader.readAsDataURL(input.files[0]); */
            this.toggleLoading()
          }else{
            this.toggleLoading()
          }
          
        })
      }
    },
    onDownloadAttachment(uiid){
      /* this.downloadAttachment({
        id:uiid
      }).then(res => {
        if(res.data.errorMessage){
          alert(res.data.errorMessage)
        }else{
          if(res.data){  
            this.$nextTick().then(() => {
              this.$refs.downloader.downloadFile(res.config.baseURL.replace('api', '') +  res.data.path)
            })
          }
        }
        
      }) */
      this.downloadAttachment({
        id:uiid
      }).then(res => {
        if(res.data.errorMessage){
          alert(res.data.errorMessage)
        }else{
          if(res.data.attachment){
            const url = res.data.baseUrl + '/' +  res.data.attachment.path
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', res.data.attachment.originalname) //or any other extension
            link.setAttribute('target', '_blank') //or any other extension
            document.body.appendChild(link)
            link.click()
            link.remove()
            /* this.$nextTick().then(() => {
              this.$refs.downloader.downloadFile(res.config.baseURL.replace('api', '') +  res.data.path)
            }) */
          }
        }
        
      })
    },
    onDeleteAttachment(uiid, idx){
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete selected attachment?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DELETE',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.deleteAttachment({
            id:uiid
          }).then(res => {
            if(res.data.success){
              alert('Attachment was successfully deleted!')
            }
            this.model.attachments.splice(idx, 1)
          })
        }
      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/administration/user')
    }
  },
  filters: {
    date: function (value, format) {
      return moment(value).format(format || 'YYYY-MM-DD')
    },
    custom_date: function (value) {
      return moment(value).format('Mo MMMM YYYY')
    }
  }
}
</script>


<style>
  .ps__rail-y{
    z-index:1
  }
  .ps__rail-x{
    z-index:1
  }
</style>